<template>
  <div class="scoring-wrapper" style="height: 100vh; overflow-y: auto;">
    <el-container class="scoring" :style="scoringStyle">
        <el-header style="height: 60px; flex-shrink: 0;">
            <el-row>
              <el-col :span="6">
                <span style="display: block;line-height: 2" >红色框选位置为本账号批阅记录(可修改) </span>
                <span  style="display: block;line-height: 2" >蓝色框选位置为其他账号批阅(不可修改)</span>
              </el-col>
                <el-col :span="12">
                  请选择{{ classTitle }}

                  <el-select v-model="chooseClassId" placeholder="请输入或选择班级" filterable style="margin-left: 20px;width: 300px" @change="getMenuData">
                    <el-option 
                      v-for="item in classList" 
                      :key="item.id" 
                      :label="item.name" 
                      :value="item.id">
                    </el-option>
                    
                  </el-select>

                  <!-- 混合班级 -->
                  <el-checkbox v-model="isChecked" style="margin-left: 10px;">混合班级检查</el-checkbox>
                </el-col>
                <el-col :span="6">
                  
              </el-col>
            </el-row>

        </el-header>

        <el-container style="flex: 1; overflow: visible;">
          <!-- 侧边栏 -->
          <!-- :width="asideWidth" -->
          <el-aside  width="10%" style="overflow: visible; height: auto;" ref="aside">
            <div class="aside-scroll-container" style="height: calc(100vh - 60px); overflow-y: auto;">
              <el-menu 
                v-if="chooseClassId != null"
                default-active="2" 
                class="el-menu-vertical-demo"  
                @open="handleOpen" 
                @close="handleClose" 
                :style="{ height: menuHeight+'px', paddingLeft: 0 }"  
                @select="handleMenuClick"
              >
                
                <el-submenu index="1">
                  <!-- 标题部分 -->
                  <template slot="title">
                    <i class="el-icon-location"></i>
                    <span>{{ menuData.name }}</span>
                  </template>

                  <!-- 内容 -->
                  <el-menu-item v-for="(item,index) in menuData.children" :key="index"  :index="index">
                    <span :style="{ color: item.total_score_num < totalScore * 0.6 ? 'red' :  item.total_score_num >= totalScore * 0.85 ? 'blue' :'black' }">
                      {{ item.menuName }}
                    </span>
                  </el-menu-item>


                </el-submenu>

              </el-menu>
            </div>
          </el-aside>

          <!-- 主内容 -->
          <el-main style="padding: 0; text-align: left;">
            <scoringCanvas v-if="selRight!=null" ref="rightPage" :info="selRight" :teacherId= "teacherId" :percentType="percentType" @ok="examChange" @changeExam="examChange" ></scoringCanvas>

          </el-main>

        </el-container>

    </el-container>
  </div>
</template>

<script>
    import * as mUtils from '@/utils/mUtils'
    import {mapState, mapActions} from 'vuex'
    import * as simpleApi from "request/simple";
    import rightPanel from "./rightPanel";
    import operPanel from "./operPanel";
    import scorePoint from "./scorePoint";
    import searchDialog from "./searchDialog";
    import recentList from "./recentList";
    import scoringCanvas from "./scoringCanvas";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
    import XEUtils from "xe-utils";
    import {splitTime, suoXiao} from "../../../utils/mUtils";
    import key from 'keymaster'
    

    export default {
        name: 'scanPre',
        data(){
            return {
              // 是否折叠菜单栏
              isCollapse: false,
              asideWidth: "200px",
              menuHeight: 0,
              menuData:{},
              examId: null, 
              // 下拉选择班级列表
              classTitle: "行政班",
              // 下拉选择班级类型
              classType:'hard',
              mixClassType:'hard',
              classList: [],
              // 选中的班级id
              chooseClassId: null,
              studentList:[],
              selRight: null,
              teacherId: null,
              mainStyle: {},
              formStyle: {}, 
              // 混合班级（先筛教学班后添行政班）
              isChecked: false,
              // 考试总分
              totalScore: 0,
              // 客观题换算比例版本
              percentType: false
            }
        },
        components:{
            ElImageViewer, rightPanel, operPanel, scorePoint, searchDialog, recentList,scoringCanvas
        },
        computed:{
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),

        },
        created() {

        },
      	mounted() {
            let examId = this.$route.query.examId;
            if(examId && examId != null){
                this.examId = parseInt(examId);
            }
            this.teacherId = this.userInfo.id
            // 加载考试总分
            this.getTotalScoreByExamId()
            // 加载班级列表
            this.filterClassType()
            // 加载答题卡信息
            this.getScantronInfo()
	    },
        watch: {
            examId: {
                deep: true, immediate:true,
                handler(n, o){

                    // if(n){
                    //     this.reload();
                    // }
                }
            },
            isCollapse: {
                deep: true, immediate: true,
                handler(n, o) {
                  debugger
                    let myHeight = document.documentElement.clientHeight ;
                    let myWidth = document.documentElement.clientWidth ;
                    if(!this.isCollapse){
                        this.asideWidth = "200px";
                        this.mainStyle.width = (this.formStyle.width - 200) + "px";
                        this.canvasWidth = myWidth -600;
                    }else{
                        this.asideWidth = "50px";
                        this.mainStyle.width = (this.formStyle.width - 50) + "px";
                        this.canvasWidth = myWidth -450;
                    }
                    this.drawList = [];
                    // this.loadCanvas();
                    this.$set(this, "mainStyle", this.mainStyle);
                }
            },
            isChecked: {
                deep: true, immediate:false,
                handler(n, o){
                  this.mixClass()
                }
            },

        },
        methods: {

          // 加载对应考试的班级列表(行政班/教学班)
          filterClassType(){
            let search = {
              examId: this.examId
            }
            let param = { controllerName: 'score/ctrl', methodName: '/teacher/filterClass',  param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
              if (code == 0) {
                if(data.type === 'teachingClass') {
                  this.classTitle = '教学班'
                  this.classType = 'teaching'
                }
                this.classList = data.classList
              }
            }).catch((error) => {
               
                console.log("error")
            });
          },
          async getMenuData(){
            // debugger
            // 展开菜单 计算菜单栏目高宽
            this.isCollapse = true
            // 获取对应的班级信息 ，构建菜单栏
            let classId = this.chooseClassId
            let classInfo = this.classList.find(item => item.id == classId)
            if(this.classType == 'mix') this.mixClassType = classInfo.mixClassType
            // 子菜单
            let children = await this.getHardClass()

            let menuData = {
              key: 'root',
              name: classInfo.name,
              icon: "el-icon-user",
              children: children
            }

            
            

            let that = this;
            this.$nextTick(() => {
                that.menuData = menuData
                that.menuHeight = document.documentElement.clientHeight-80;
            });
          },
          // 获取教学班/行政班/混合班级 对应的学生信息
          getHardClass(){
            debugger
            this.studentList = []
            let classType = this.classType
            if(this.classType == 'mix') classType = this.mixClassType
            let search = {
              examId: this.examId,
              classType: classType,
              classId: this.chooseClassId
            }
            let param = { controllerName: 'scan/scanPreResult', methodName: '/getStudentListByClassId',  param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
              // debugger
              this.studentList = data
              let list = []
               // 处理数据格式
               data.forEach((ele,index) => {
                // debugger
               })
               return data
            })
          },
          // 菜单点击事件
          handleMenuClick(index){
            // debugger
            // 获取到对应的学生信息 并渲染整张试卷
            let studentInfo = this.studentList[index]
            let i =1
            this.selRight = studentInfo
          },
          // 混合班级模式
          mixClass(){
            // this.isChecked = !this.isChecked
            // debugger
            // 清空页面
            this.chooseClassId = null
            this.selRight = null
            this.menuData = {}

            if(this.isChecked){
              this.getMixClassList()
            }else{
              // 刷新
              this.filterClassType()
            }
          },
          // 加载对应考试的班级列表(行政班/教学班)
          getMixClassList(){
            // debugger
            let search = {
              examId: this.examId
            }
            let param = { controllerName: 'score/ctrl', methodName: '/teacher/mixClassType',  param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
              if (code == 0) {
                  this.classTitle = '混合班级'
                  this.classType = 'mix'
                  this.classList = data
              }
            }).catch((error) => {
               
                console.log("error")
            });
          },
          // 获得考试总分
          getTotalScoreByExamId(){
            let search = {
              examId: this.examId
            }
            let param = { controllerName: 'akExamTopic', methodName: '/getTotalScoreByExamId',  param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
              this.totalScore = data.score
            }).catch((error) => {
                console.log("error")
            });
          },
          // 加载当前关联答题卡类型
          getScantronInfo(){
            let param = { controllerName: 'exam/scantron', methodName: '/getSheetByExamId', param: { examId: this.examId}};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                // this.scantronInfo = data
                this.percentType = mUtils.getPercentType(data.updateTime)

            });
          },







        },



    }
</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">

    // .scoring{
    //     .item {
    //         margin: 4px;
    //     }
    //     .el-header {
    //         // background-color: #02b6fd;
    //         color: white;
    //         line-height: 60px;
    //         .icon {
    //             line-height: 60px;
    //             height: 30px;
    //             width: 30px;
    //             font-size: 26px;
    //         }
    //         .head {
    //             font-size: 16px;
    //             text-align: left;
    //         }
    //     }
    //     .el-aside {
    //         color: #333;
    //     }

    // }
    .btn {
      padding: 8px 16px;
      border: 1px solid #ddd;
      background: white;
      cursor: pointer;
      margin: 5px;
    }

    .btn.active {
      background: #007bff;
      color: white;
      border-color: #007bff;
    }

    .scoring-wrapper {
      height: 100vh;
      overflow-y: auto;  // 整个页面滚动
    }

    .scoring {
      height: auto;
      min-height: 100%;

      .el-header {
        height: 60px;
        line-height: 60px;  // 让文字垂直居中
        color: white;
        // background: white;   // 白色背景
        // border-bottom: 1px solid #eee;  // 可选：加个下边框
      }
      
      .el-aside {
        overflow: visible;
        height: auto;  // 侧边栏高度自适应，跟随页面滚动
      }
      
      // 侧边栏内部滚动容器
      .aside-scroll-container {
        position: sticky;
        top: 0;  // 让滚动容器相对于视口固定高度
      }
    }


</style>


